//@flow

export const siteWidth = '1040px'


// WEBPACK FOOTER //
// ./src/theme/spacing.js